import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './provider/app-provider.tsx';
import { router } from './routes/routes.tsx';
import './styles/app.scss';

export function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}
